import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getFormValues } from "redux-form";
import BookList from "./BookList";
import { logout } from "../../../common/actionCreators/";
import { bookClear } from "../../bookDetail/actionCreators";
import { booksAction, booksClearAction } from "../actionCreators/";

const BookListContainer = ({ values }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  // 도서 신청 직후 진입 시 접수 안내 메시지
  const [batchSubmitted, setBatchSubmitted] = useState(false);

  // 신청 화면에서 navigate("/", { state: { batchSubmitted: true } }) 로 넘어온 경우.
  // 새로고침/재진입 시 중복 표시 안 되도록 history state 는 바로 정리.
  useEffect(() => {
    if (location.state && location.state.batchSubmitted) {
      setBatchSubmitted(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const { books, booksError, isBookRequesting } = useSelector(
    ({ bookListReducer, form }) => ({
      books: bookListReducer.books,
      booksError: bookListReducer.booksError,
      isBookRequesting: bookListReducer.isBookRequesting,
      search: form.searchBarForm
    })
  );

  const onSubmit = e => {
    let { selectCondition = null, selectValue = null } = values;

    if (selectCondition === "reqType") {
      if (selectValue === "개인") {
        selectValue = "01";
      } else {
        selectValue = "02";
      }
    }

    dispatch(
      booksAction({
        selectValue: selectValue,
        selectCondition: selectCondition
      })
    );
  };

  const onTableRowClick = useCallback(
    ordNum => {
      navigate(`/book/${ordNum}`);
    },
    [navigate]
  );

  useEffect(() => {
    dispatch(booksClearAction());
    dispatch(bookClear());

    // 토큰 만료(F00001)는 baseApi.interceptors.response 에서 처리.
    // 다른 에러로 강제 로그아웃 시키지 않음 — 사용자 세션 유지.
    if (booksError) {
      // eslint-disable-next-line no-console
      console.warn("[bookList] api error:", booksError);
      return;
    }

    dispatch(booksAction(null));
  }, [dispatch, booksError]);

  // 로딩바
  useEffect(() => {
    if (isBookRequesting) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isBookRequesting]);

  return (
    <BookList
      books={books}
      onTableRowClick={onTableRowClick}
      onSubmit={onSubmit}
      Loading={loading}
      batchSubmitted={batchSubmitted}
      onDismissBatchSubmitted={() => setBatchSubmitted(false)}
    ></BookList>
  );
};

export default connect(state => ({
  values: getFormValues("searchBarForm")(state)
}))(BookListContainer);
